'use client';

import { cn } from '@/lib/cn';
import { getRelationFieldNames } from '@/requests/instanceMapper';
import { QuotaFeeConfig, type QuotaFee } from '@pigello/pigello-matrix';
import Dot from './dot';
import type { RelationFieldProps } from './types';

export const QuotaFeeItem: RelationFieldProps<QuotaFee> = {
  nested: getRelationFieldNames(QuotaFeeConfig),
  filters: [],
  renderItem: (item, isRelationField) => ({
    title: item.customId,
    descriptionItems: (
      <div
        className={cn(
          isRelationField ? 'grid w-full' : 'flex flex-wrap items-center'
        )}
      >
        <div className='font-medium'>{item.article?.name}</div>
        {!isRelationField && <Dot />}
        <div
          className={cn(
            'flex items-center',
            isRelationField && 'w-full justify-between'
          )}
        >
          <span>{item.quotaCollection?.name}</span>
          {!isRelationField && <Dot />}
          <span> {item.customId ?? 'Inget objekts-id angivet'}</span>
        </div>
      </div>
    ),
  }),
};
